<!-- Toaster -->
<app-toaster></app-toaster>
@if (loader) {
<div
  class="d-flex align-items-center justify-content-center"
  style="height: 100vh; width: 100vw"
>
  <div class="spinner-grow" style="width: 3rem; height: 3rem" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
} @else {
<router-outlet></router-outlet>
}
